import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "videocall_5cf08d57096b175b7a05b289fe5f6af8",
  "use": "videocall_5cf08d57096b175b7a05b289fe5f6af8-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"videocall_5cf08d57096b175b7a05b289fe5f6af8\">\n    <path sfill-rule=\"evenodd\" d=\"M16.5 8.5v7c0 .966-.806 1.75-1.8 1.75H4.8c-.994 0-1.8-.784-1.8-1.75v-7c0-.966.806-1.75 1.8-1.75h9.9c.994 0 1.8.784 1.8 1.75zm.9 5.688V9.811l2.223-1.35a.915.915 0 0 1 1.24.278c.09.139.137.3.137.464v5.592a.888.888 0 0 1-.9.875.92.92 0 0 1-.477-.133l-2.223-1.35z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol